<template>
  <div class="md-layout align-modal-center">
    <div id="modal-overlay" v-if="showCart()"></div>
    <div
      id="cart-modal"
      lang="en"
      role="dialog"
      aria-labelledby="dialog1Title"
      aria-describedby="dialog1Desc"
      class="cb-hp cb-hp--transition"
      v-if="showCart()"
    >
      <div class="cb-hp__wrapper">
        <div
          id="cb-header"
          class="cb-header cb-transition__slide"
          style="height: auto; overflow: initial;"
        >
          <div
            id="cb-header-wrap"
            role="banner"
            class="cb-header__wrap cb-transition__slide"
          >
            <div class="cb-header__logo cb-transition__slide">
              <img
                src="https://s3.amazonaws.com/cb-invoice-logos-prod/frznmtn-test/logo_1548192985.png"
                alt="logo"
                class="cb-header__image"
              />
            </div>
            <div
              id="cb-header-title"
              class="cb-header__title cb-transition__slide"
              style="color: rgb(33, 150, 243); opacity: 1;"
            >
              {{ cart_title }}
            </div>
          </div>
        </div>
        <div id="cb-body" role="main" class="cb-body">
          <div class="cb-body__wrap " style="min-height: 392px;">
            <div class="cb-body__content">
              <div class="cb-cart" v-for="item in cart_items" :key="item.externalId">
                <div
                  class="cb-item cb-transition__tab"
                  style="color: rgb(33, 150, 243);"
                >
                  <div class="cb-item__group">
                    <div class="cb-item__sub-group">
                      <div class="cb-item__price cb-item__sub-group--right">
                        <label>
                          <input
                            type="radio"
                            v-model="selected_item"
                            :value="item.externalId"
                            :disabled="!selecting_plan && currentAddon(item)"
                          >
                            {{
                              "$" + item.price / 100 + " / Month"
                            }} <span class="small-text">{{ selecting_plan ? "" : currentAddon(item) ? "- Current Support" : ""}}</span>
                          </input>
                        </label>
                        <div class="cb-item__name  cb-item__sub-group--left">
                          {{ item.name }}
                        </div>
                        <div class="cb-item__captions-wrap">
                          <div class="cb-item__caption">
                          {{ item.description }}
                          </div>
                        </div>
                        <span v-if="!selecting_plan && wasFreeText(item.price)" class="to-free"
                          >You will lose the benefits of your paid support by
                          switching to Free Support
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cb-body__footer">
              <div class="cb-action">
                <button
                  data-cb-id="cart_submit"
                  @click="nextStep()"
                  class="cb-button cb-button__primary cart-next"
                  style="background-color: rgb(33, 150, 243); color: rgb(33, 150, 243);"
                >
                  <span class="cb-button__text">
                    Next <i class="icon-long-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        role="button"
        aria-label="close checkout"
        data-cb-id="cb_close"
        class="cb-hp__close"
        style="outline: none;"
        @click="closeModal()"
      >
        <i class="icon-remove cb-hp__close-icon"></i>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import { setSubscriptionStatus } from "../utils/auth0";
import swal from "sweetalert2";
export default {
  data() {
    return {
      show_cart: 0,
      cart_items: [],
      selected_item: null,
      planId: null,
      cart_title: "",
    };
  },
  methods: {
    showCart: function() {
      return (this.show_cart === 1 || this.show_cart === 2);
    },
    nextStep: function() {
      if(this.selected_item === null) {
        return;
      }
      
      if(this.show_cart === 1)
      {
        this.planId = this.selected_item;
        this.$store
          .dispatch("chargebee/getSupportPlans", this.planId)
          .then(result => {
            this.cart_items = result;
            this.show_cart = 2;
            this.cart_title = "Select your Support";
            this.selected_item = null;
          });
      } else if(this.show_cart === 2)
      {
        var addon = null;
        //get the addon we selected
        for(var i = 0; i < this.cart_items.length; i++) {
          if(this.cart_items[i].externalId == this.selected_item) {
            addon = this.cart_items[i];
            break;
          }
        }

        //we are switching to a free plan so we have to update the subscription differently
        if(addon !== null && addon.price === 0 && !this.selecting_plan) {
          var subscription = this.$store.get('subscription/subscription');
          var html = "<strong>Are you sure?</strong><br /><br />" +
          "Continuing will immediately cancel your support plan and will stop priority access to the LiveSwitch Cloud" +
          "support team and all plan benefits described <a href='https://www.liveswitch.io/support-pricing' target='_blank'>here</a>.";
          
          if (api.props.config.environment === "nightly") {
            html = `<iframe src='https://www.liveswitch.io/sup-downgrade-free-lsqa' style='height:185px;width:100%;margin-bottom:20px;position:relative;top:20px;' scrolling='no'></iframe>`;
          } else if (api.props.config.environment === "prod") {
            html = `<iframe src='https://www.liveswitch.io/sup-downgrade-free' style='height:185px;width:100%;margin-bottom:20px;position:relative;top:20px;' scrolling='no'></iframe>`;
          }

          swal
            .fire({
              html: html,
              showCancelButton: true,
              confirmButtonClass: "md-button md-success btn-fill",
              cancelButtonClass: "md-button md-danger btn-fill",
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              buttonsStyling: false
            })
            .then(result => {
              if (result.value) {
                subscription.supportPlan = addon;
                this.$store
                .dispatch("subscription/updateSubscription", subscription)
                .then(() => {
                  swal.fire({
                    title: "Updated!",
                    text: `Your subscription support has been updated to ${subscription.supportPlan.name}`,
                    type: "success",
                    confirmButtonClass: "md-button md-success btn-fill",
                    buttonsStyling: false
                  })
                  .then(() => {
                    window.location.replace("#/subscription");              
                    window.history.pushState({}, document.title, "/#/subscription");
                  });
                });
              }
          });
        }
        else {
          var selectedPlans = {
            hosted_type: this.selecting_plan ? "new" : "updated",
            planQuantity: 1,
            planId: this.planId,
            subscriptionId: localStorage.subscriptionId,
            addonsId0: this.selected_item,
            addonsQuantity0: 1
          };
          this.selecting_plan = false;
          this.$store.dispatch("chargebee/getHostedPage", selectedPlans);
        }
      }
      this.show_cart++;
    },
    startCheckout: function(subscription, query) {
      //if this query is present then it is a CTA landing here
      this.planId = (subscription !== undefined && subscription.platformPlan.externalId) ? subscription.platformPlan.externalId : query.get("planId");
      if (query.has("start_cart")) {
        this.$store
          .dispatch("chargebee/getSupportPlans", this.planId)
          .then(result => {
            this.cart_items = result;
            this.show_cart = 2;
            this.cart_title = "Select your Support";
            if(this.cart_items.length === 1) {
              this.selected_item = this.cart_items[0].externalId;
            }
          });
      } else if(query.has("start_plan")){
        this.$store
          .dispatch("chargebee/getPlatformPlans")
          .then(result => {
            this.cart_items = result;
            this.show_cart = 1;
            this.cart_title = "Select your Plan";
            this.selecting_plan = true;
            if(this.cart_items.length === 1) {
              this.selected_item = this.cart_items[0].externalId;
            }
          });
      } else if (query.has("hosted_type")) {
        var entries = Array.from(query.entries());
        var selectedPlans = {
          hosted_type: query.get("hosted_type"),
          planQuantity: query.get("planQuantity"),
          planId: this.planId,
          subscriptionId: localStorage.subscriptionId,
          reactivatePlan: query.get("reactivatePlan"),
          completeUrl: query.get("completeUrl"),
          closeUrl: query.get('closeUrl')
        };
        for (var i = 0; i < entries.length; i++) {
          if (entries[i][0].indexOf("addons") != -1) {
            selectedPlans[entries[i][0]] = entries[i][1];
          }
        }
        this.$store.dispatch("chargebee/getHostedPage", selectedPlans);
      }
    },
    landMethod: function() {
      var query = new URLSearchParams(window.location.search);
      if(query.keys.length === 0) {
        var split = window.location.hash.split("?");
        if(split.length == 2) {
          query = new URLSearchParams(decodeURIComponent(split[1]));
        }
      }
      if (query.has("hosted_type") || query.has("start_plan") || query.has("start_cart")) {
        if (localStorage.subscriptionId) {
          this.$store.dispatch(
            "subscription/loadSubscription",
            localStorage.subscriptionId
          ).then(result => {
            setSubscriptionStatus(result.status);
            this.startCheckout(result, query);
          });
        }
        else {
          this.startCheckout(undefined, query);
        }
      }
    },
    wasFreeText: function(price) {
      if (price === 0) {
        var subscription = this.$store.get("subscription/subscription");
        if (subscription !== null) {
          if (
            subscription.supportPlan !== null &&
            subscription.supportPlan.price !== 0
          ) {
            return true;
          }
        }
      }
      return false;
    },
    currentAddon: function(item) {
      var subscription = this.$store.get("subscription/subscription");
      if (subscription !== null &&
        subscription.supportPlan != null &&
        subscription.supportPlan.externalId == item.externalId
      ) {
        return true;
      }
      return false;
    },
    closeModal: function() {
      var query = new URLSearchParams(window.location.search);
      if(query.has('closeUrl')) {
        window.location = query.get('closeUrl');
      } else {
        window.location.href = "#/subscription";      
        window.location.search = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#modal-overlay {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.7);
}
.to-free {
  font-size: 10px;
  color: red;
}
.small-text {
  font-size: 10px;
}

.align-modal-center{
  justify-content: center;
}

#cart-modal {
  height: auto;
   margin-top: 244.5px;
   transition-duration: 400ms;
   margin:0;
   z-index:9999;
   top:15%;
   position:absolute;
}

@media screen and (max-width: 479px) {
  #cart-modal {
    top: 0;
  }
}
</style>
